import { z } from 'zod';

export * from './auth';
export * from './users';
export * from './hotels';
export * from './hotel-facts';
export * from './hotel-events';
export * from './hotel-media';
export * from './intake';
export * from './monthly-plans';
export * from './posts';
export * from './post-next-step';
export * from './post-topics';
export * from './post-contents';
export * from './post-images';
export * from './comments';
export * from './client-reply';
export * from './ai';
export * from './token-usage';
export * from './client-attachments';
export * from './approvals';
export * from './ai-settings';
export * from './reserve-content';
export * from './event-extraction';
export * from './hotel-notification-recipients';
export * from './hotel-contacts';
export * from './email-templates';
export * from './email-letters';
export * from './approval-reminder-settings';
export * from './digest';
export * from './media-vocab';
export * from './queues';
export * from './features';
export * from './client-calendar';
export * from './api-tokens';

export const HealthSchema = z.object({
  status: z.literal('ok'),
  uptime: z.number(),
  version: z.string(),
});
export type Health = z.infer<typeof HealthSchema>;
